/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_SubtitleInputs */

const es_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizá tus preferencias y gestioná tus integraciones`)
};

const en_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your preferences and integrations`)
};

/**
* | output |
* | --- |
* | "Manage your preferences and integrations" |
*
* @param {Settings_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_subtitle = /** @type {((inputs?: Settings_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_subtitle(inputs)
	return en_settings_subtitle(inputs)
});
export { settings_subtitle as "settings.subtitle" }